import { render, staticRenderFns } from "./ForgotPw_otp_request.vue?vue&type=template&id=270d7c5d&scoped=true&"
import script from "./ForgotPw_otp_request.vue?vue&type=script&lang=js&"
export * from "./ForgotPw_otp_request.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPw_otp_request.vue?vue&type=style&index=0&id=270d7c5d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270d7c5d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VForm,VTextField})
